import { jsx as _jsx } from "react/jsx-runtime";
import { CsAttributeController, useCsAttributeById, } from "@plansoft-configuration-renderer/framework";
import { AttributeErrorBoundary } from "./AttributeErrorBoundary";
import { AttributeNotFound } from "./AttributeNotFound";
/**
 * Extra component so we can use the hook {@link useCsAttributeById} unconditionally
 * @param props
 * @returns
 */
export function AttributeCellInner(props) {
    const attribute = useCsAttributeById(props.attributeId);
    if (!attribute) {
        return _jsx(AttributeNotFound, { attributeId: props.attributeId });
    }
    return (_jsx(AttributeErrorBoundary, { attribute: attribute, children: _jsx(CsAttributeController, { attribute: attribute, numberFormatOptions: props.numberFormatOptions, children: props.children }) }));
}
//# sourceMappingURL=AttributeCellInner.js.map